// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1QK8m","name":"Header_name__ru8MV","birthday":"Header_birthday__1Lj4h","skeleton":"Header_skeleton__1qaJB"};